import axios from 'axios';
import { handleError } from './utils';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

// INDEX FUNCTIONS

export const getNutritionByFoodItem = async (foodItemId) => {
    try {
        const res = await api.get('/nutrition', {
            params: { food_item_id: foodItemId }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch nutrition for food item');
    }
};

export const getNutritionByMealItem = async (mealItemId) => {
    try {
        const res = await api.get('/nutrition', {
            params: { meal_item_id: mealItemId }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch nutrition for food item');
    }
};

export const getNutritionByMeal = async (params) => {
    try {
        const res = await api.get('/nutrition', { params });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch nutrition');
    }
};

export const getNutritionByPeriod = async (dateStart, dateEnd) => {
    try {
        const res = await api.get('/nutrition', {
            params: {
                date_start: dateStart,
                date_end: dateEnd
            }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch nutrition for period');
    }
};

// ENERGY FUNCTIONS

export const getEnergyByFoodItem = async (foodItemId) => {
    try {
        const res = await api.get('/nutrition/energy', {
            params: { food_item_id: foodItemId }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch energy for food item');
    }
};

export const getEnergyByMeal = async (mealId) => {
    try {
        const res = await api.get('/nutrition/energy', {
            params: { meal_id: mealId }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch energy for meal');
    }
};

export const getEnergyByPeriod = async (dateStart, dateEnd) => {
    try {
        const res = await api.get('/nutrition/energy', {
            params: {
                date_start: dateStart,
                date_end: dateEnd
            }
        });

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch energy for period');
    }
};

export const getDesiredEnergy = async () => {
    try {
        const res = await api.get('/nutrition/desired-energy');

        return res.data;
    } catch (error) {
        handleError(error, 'Failed to fetch energy for period');
    }
};
